import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  workplaceName: {
    alignItems: 'center',
    display: 'inline-flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
  },
}));

export default useStyles;
